(function() {
  function initSearchModal() {
    var modal = document.getElementById('search-modal');
    var panel = document.getElementById('search-modal-panel');
    var backdrop = document.getElementById('search-modal-backdrop');
    var closeBtn = document.getElementById('search-modal-close');
    var searchComponent = document.querySelector('predictive-search');
    var input = document.getElementById('search-modal-input');
    var resultsContainer = document.getElementById('predictive-search-results-container');
    var statusEl = document.getElementById('predictive-search-status');
    var sectionId = searchComponent ? searchComponent.dataset.sectionId : 'predictive-search';
    var abortController = null;
    var debounceTimer = null;
    var isInitialized = modal && modal.dataset.searchInitialized === 'true';
    var focusTrap = window.EzsportA11y && panel ? EzsportA11y.createFocusTrap(panel) : null;
    var triggerElement = null;

    if (!modal || !input || !panel || isInitialized) return;
    modal.dataset.searchInitialized = 'true';

    function getRoutesRoot() {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        return Shopify.routes.root;
      }
      return '/';
    }

    function openModal(sourceEl) {
      triggerElement = sourceEl || document.activeElement;
      modal.classList.remove('hidden');
      modal.classList.add('flex');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (typeof lucide !== 'undefined') lucide.createIcons();
      if (focusTrap) {
        focusTrap.activate(input);
      } else {
        window.setTimeout(function() { input.focus(); }, 50);
      }
    }

    function closeModal() {
      modal.classList.add('hidden');
      modal.classList.remove('flex');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      input.value = '';
      hideResults();
      if (focusTrap) focusTrap.deactivate();
      if (triggerElement && typeof triggerElement.focus === 'function') {
        triggerElement.focus();
      }
      triggerElement = null;
    }

    function hideResults() {
      if (!resultsContainer) return;
      resultsContainer.innerHTML = '';
      resultsContainer.classList.add('hidden');
      input.setAttribute('aria-expanded', 'false');
    }

    function showResults(html) {
      if (!resultsContainer) return;
      resultsContainer.innerHTML = html;
      resultsContainer.classList.remove('hidden');
      input.setAttribute('aria-expanded', 'true');
      if (typeof lucide !== 'undefined') lucide.createIcons();
    }

    function fetchResults(term) {
      if (!window.EzsportConfig || !window.EzsportConfig.enablePredictiveSearch) {
        return;
      }
      if (!term.length) {
        hideResults();
        return;
      }

      if (abortController) abortController.abort();
      abortController = new AbortController();

      var params = new URLSearchParams({
        q: term,
        'resources[type]': 'product,query,collection,page,article',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        section_id: sectionId
      });

      fetch(getRoutesRoot() + 'search/suggest?' + params.toString(), {
        signal: abortController.signal
      })
        .then(function(res) { return res.text(); })
        .then(function(text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var results = doc.getElementById('predictive-search-results');
          if (results) {
            showResults(results.outerHTML);
            if (statusEl) statusEl.textContent = term;
          } else {
            hideResults();
          }
        })
        .catch(function(err) {
          if (err.name !== 'AbortError') console.error('Predictive search error:', err);
        });
    }

    document.addEventListener('click', function(e) {
      var openTrigger = e.target.closest('[data-search-open]');
      if (openTrigger) {
        e.preventDefault();
        openModal(openTrigger);
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        fetchResults(input.value.trim());
      }, 280);
    });

    input.addEventListener('focus', function() {
      if (input.value.trim().length) fetchResults(input.value.trim());
    });

    window.EzsportSearchModal = { open: openModal, close: closeModal };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchModal);
  } else {
    initSearchModal();
  }

  document.addEventListener('shopify:section:load', initSearchModal);
})();
